<template lang="pug">
.privacy-policy
  div(v-if="$i18n.locale === 'en'")
    PrivacyEn
  div(v-else)
    PrivacyZh
  Separator(class="my-4")
  span {{$t('last-revision')}} 13/03/2021
</template>

<script setup>
import { Separator } from '@/components/ui/separator'
import PrivacyEn from '~/components/dif-lang/PrivacyEn'
import PrivacyZh from '~/components/dif-lang/PrivacyZh'
</script>

<style lang="postcss">
.privacy-policy {
  text-align: left;
  max-width: var(--secondary-max-width);
  padding: 0 1rem 3rem;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 1rem;
    /* margin-bottom: 1rem; */
  }

  h1,
  h2,
  h3 {
    line-height: 1.25;
    margin-top: 3rem;
    font-weight: 500;
  }

  h1 {
    font-size: 2.5rem;
    font-weight: 600;
  }

  summary {
    display: list-item;
    cursor: pointer;
  }

  /* color: var(--secondary-color); */
  font-size: 1rem;
  line-height: 2;

  ul {
    padding-left: 1.5rem;
  }
}
</style>
